import { z } from 'zod'
import { isInvalidString, REQUIRED_BASIC_MESSAGE } from '../constants/constants'
import { YesOrNoSchema } from './application-shared.schema'

export const BankingSchema = z
  .object({
    canReceiveACH: YesOrNoSchema,
    federalTaxId: z.string().optional(),
    accountType: z.string().optional(),
    depositoryName: z.string().optional(),
    branch: z.string().optional(),
    bankStreetAddress: z.string().optional(),
    bankStreetAddress2: z.string().optional(),
    bankCity: z.string().optional(),
    bankState: z.string().optional(),
    bankRoutingId: z.string().optional(),
    accountNumber: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    type Keys = keyof typeof data

    const addFieldError = (field: Keys) => {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: [field],
        message: REQUIRED_BASIC_MESSAGE,
      })
    }

    if (data.canReceiveACH === 'Yes') {
      if (isInvalidString(data.federalTaxId)) {
        addFieldError('federalTaxId')
      }
      if (isInvalidString(data.accountType)) {
        addFieldError('accountType')
      }
      if (isInvalidString(data.depositoryName)) {
        addFieldError('depositoryName')
      }
      if (isInvalidString(data.bankStreetAddress)) {
        addFieldError('bankStreetAddress')
      }
      if (isInvalidString(data.bankCity)) {
        addFieldError('bankCity')
      }
      if (isInvalidString(data.bankState)) {
        addFieldError('bankState')
      }
      if (isInvalidString(data.bankRoutingId)) {
        addFieldError('bankRoutingId')
      }
      if (isInvalidString(data.accountNumber)) {
        addFieldError('accountNumber')
      }
    }
  })

export type BankingData = z.infer<typeof BankingSchema>
